const txteng10a = [
  ["это случилось вчера", "It happened yesterday"],
  ["они помогли мне на прошлой неделе", "They helped me last week."],
  ["она жила здесь в октябре", "She lived here in October."],
  [
    "Мы хотели купить дом в прошлом июне",
    "We wanted to buy a house last June.",
  ],
  [
    "Мне нужна была помощь позавчера.",
    "I needed help the day before yesterday.",
  ],
  ["Он узнал меня вчера.", "He recognized me yesterday."],
  ["Она открыла окно 2 часа назад.", "She opened the window two hours ago."],
  ["Они ждали в прошлое воскресенье.", "They waited last Sunday."],
  ["Ты жил здесь 10 лет назад.", "You lived here ten years ago."],
  ["В прошлом году я ремонтировал машину.", "I fixed the car last year."],
  [
    "Ему нужно было закрыть двери 5 минут назад.",
    "He needed to close the door five minutes ago.",
  ],
  ["Это случилось в прошлом апреле.", "It happened last April."],
  ["Мы работали в мае.", "We worked in May."],
  ["Вчера я хотел подождать.", "I wanted to wait yesterday."],
  ["Она поверила мне в четверг.", "She believed me Thursday."],
  ["Она хотела жить в Бостоне.", "She wanted to live in Boston."],
  [
    "Это случалось каждый день на прошлой неделе.",
    "It happened every day last week.",
  ],
  ["Нам нужно было поработать в понедельник.", "We needed to work on Monday."],
  ["Я закрыл дверь и открыл окно.", "I closed the door and opened the window."],
  ["Я поверил в это позавчера.", "I believed it the day before yesterday."],
  ["Вчера им понравился дом.", "They liked the house yesterday."],
  [
    "Они жили и работали здесь в прошлом году.",
    "They lived and worked here last year.",
  ],
  ["Он открыл двери и узнал меня.", "He opened the door and recognized me."],
];

export default txteng10a;
